// extracted by mini-css-extract-plugin
export default {"PfsYorke":"PFSYorke_PfsYorke__e13nB","content":"PFSYorke_content__Ral7m","homeBtn":"PFSYorke_homeBtn__VPJR6","logo":"PFSYorke_logo__S8dxk"};